import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import { UPDATE_QUESTION_ANSWER, GET_QUESTIONS_SUCCESS } from '../types'
import HELPER from './helper';

const getListQuestion = (payload) => {
  const question = get(payload, 'data.questionnarie.questions', null);
  if (question) {
    const flatList = [];
    HELPER.flattenQuestions([question], flatList);
    return flatList.filter(q => q.display_type === 'list' && q.submission_type === 'all')[0];
  }
  return [];
}

const createRequiredSchema = (payload) => {
  const listQuestion = getListQuestion(payload);
  if (!listQuestion) return [];
  let targetList = [];
  if (listQuestion.questions) { // look for last item in array to determine required schema
    // listQuestion.questions should be an array of array
    if (isArray(listQuestion.questions)) {
      targetList = listQuestion.questions[listQuestion.questions.length - 1];
    } else {
      return [];
    }
  } else {
    targetList = listQuestion.original_questions;
  }
  const flatList = [];
  HELPER.flattenQuestions(targetList, flatList);
  return flatList.reduce((acc, q) => {
    if (q.question_type !== 'group' && get(q, 'validations.required.value', false)) {
      acc.push(q.question_id);
    }
    return acc;
  }, []);
}

// checks for valid answer
const isValidAnswer = (response) => {
  if (isArray(response) && !response.length) {
    return false;
  }
  if (isPlainObject(response) && !response.id) {
    return false;
  }
  return Boolean(response);
}

const createAnswersArray = (payload) => {
  const { questionId, response } = payload;
  return {
    questionId,
    response: isValidAnswer(response),
  }
}

const shouldEnableAdd = (requiredSchema, answersArray) => {
  if (answersArray.filter(q => q.response).length < requiredSchema.length) {
    return false;
  }
  for (let index = 0; index < requiredSchema.length; index += 1) {
    const qId = requiredSchema[index];
    const hasAnswer = answersArray.filter(q => q.questionId.indexOf(qId) && q.response)[0];
    if (!hasAnswer) {
      return false;
    }
  }
  return true;
}
// ########### REDUCER ###########

const initialState = {
  enableAdd: false,
  requiredSchema: [],
  answersArray: [],
};

export default function nList(state = initialState, action) {
  const { type, payload } = action;
  let answersArray = []
  if (payload) {
    const { questionId } = payload;
    switch(type) {
      case UPDATE_QUESTION_ANSWER:
        if (questionId.match(/_\$ureify_/g)) {
          answersArray = [
            ...state.answersArray,
            createAnswersArray(payload),
          ]
          return {
            ...state,
            answersArray,
            enableAdd: shouldEnableAdd(state.requiredSchema, answersArray),
          };
        }
        return state;
      case GET_QUESTIONS_SUCCESS:
        return {
          ...state,
          requiredSchema: createRequiredSchema(action.payload),
          answersArray: [],
          enableAdd: false,
        };
      default:
        return state;
    }
  }
  return state;
}
